import { useSyncFw } from 'components/AdminDashboard/components/UsersPage/components/SyncFWModal/hooks';

import React from 'react';
import { Box, Button, Grid, Modal, Paper, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';

interface Props {
  onCancel: () => void;
  userId: number;
}

const SyncFWModal: React.FC<Props> = ({ onCancel, userId }) => {
  const { sync, isLoading } = useSyncFw(onCancel);

  return (
    <Modal open>
      <Paper
        sx={{
          borderRadius: '20px',
          elevation: 9,
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          outline: 'none',
          padding: 3,
          width: { xs: '100%', md: '600px' },
        }}
        data-testid="modal-sync-fw-flow"
      >
        <Box>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="textXLBold">
                Start FW synchronization
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography>
                Are you sure you want to start FW synchronization for this user?
              </Typography>
            </Grid>
            <Grid container spacing={2} item xs={12}>
              <Grid item>
                <LoadingButton variant="contained" onClick={() => sync(userId)} loading={isLoading} data-testid="button-restart">
                  Yes
                </LoadingButton>
              </Grid>
              <Grid item>
                <Button variant="outlined" onClick={onCancel} disabled={isLoading}>
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Modal>
  );
};

export default SyncFWModal;
